export default "__VITE_ASSET__BKDiUmU6__"